import React from 'react';
import { Hero } from '../components/Hero';
import { ServiceCategories } from '../components/ServiceCategories';
import { Certifications } from '../components/Certifications';

export function HomePage() {
  return (
    <>
      <Hero />
      <ServiceCategories />
      <Certifications />
    </>
  );
}